import React, { Component } from 'react';
import classNames from 'classnames';
import Style from './index.less';

export interface IRightSideBarWrapperProps {
    willShow?: (rsBar: RightSideBarWrapper) => void;
    didHide?: (rsBar: RightSideBarWrapper) => void;
    id?: string;
    width?: number;
}

export interface IRightSideBarWrapperState {
    visible: boolean;
    animating: boolean;
}

export class RightSideBarWrapper extends Component<IRightSideBarWrapperProps, IRightSideBarWrapperState> {
    public state = {
        visible: false,
        animating: false,
    };

    public show() {
        this.props.willShow?.(this);
        this.setState({
            visible: true,
            animating: true,
        });
    }

    public hide() {
        if (this.displaying) {
            this.setState({
                visible: false,
                animating: true,
            });
        }
    }

    public animationEnd() {
        this.setState({ animating: false });
        if (!this.state.visible) {
            this.props.didHide?.(this);
        }
    }

    public get displaying() {
        return this.state.animating || this.state.visible;
    }

    public render() {
        const {
            id = 'base', width,
        } = this.props;

        return (
            <div
                id={`rs-bar-${id}`}
                className={classNames(
                    Style[this.state.animating ? 'rs-bar-wrapper-animating' : 'rs-bar-wrapper-hold'],
                    this.state.visible ? Style.enter : Style.leave,
                    Style[`rs-bar-${id}`],
                )}
                onAnimationEnd={this.animationEnd.bind(this)}
                style={{
                    display: this.displaying ? 'block' : 'none',
                    width: width ? `${width}px` : '',
                }}>
            </div>
        );
    }
}
